/* =================================================================
   os-cookie-consent — Custom cookie banner using Customer Privacy API.
   Accept and Decline both call setTrackingConsent; banner hides after choice.
   ================================================================= */
(function () {
  'use strict';

  var BANNER_ID = 'os-cookie-banner';
  var SELECTORS = {
    banner: '#' + BANNER_ID,
    accept: '[data-os-cookie="accept"]',
    decline: '[data-os-cookie="decline"]'
  };

  function getBanner() {
    return document.getElementById(BANNER_ID);
  }

  function showBanner() {
    var el = getBanner();
    if (el) {
      el.hidden = false;
    }
  }

  function hideBanner() {
    var el = getBanner();
    if (el) {
      el.hidden = true;
    }
  }

  function hasConsentChoice(consent) {
    if (!consent || typeof consent !== 'object') return false;
    var keys = ['analytics', 'marketing', 'preferences'];
    for (var i = 0; i < keys.length; i++) {
      var val = consent[keys[i]];
      if (val === 'yes' || val === 'no') return true;
    }
    return false;
  }

  function acceptCookies() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    window.Shopify.customerPrivacy.setTrackingConsent({
      analytics: true,
      marketing: true,
      preferences: true
    }, hideBanner);
  }

  function declineCookies() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    window.Shopify.customerPrivacy.setTrackingConsent({
      analytics: false,
      marketing: false,
      preferences: false
    }, hideBanner);
  }

  function attachListeners() {
    var acceptBtn = document.querySelector(SELECTORS.accept);
    var declineBtn = document.querySelector(SELECTORS.decline);
    if (acceptBtn) acceptBtn.addEventListener('click', acceptCookies);
    if (declineBtn) declineBtn.addEventListener('click', declineCookies);
  }

  function init() {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function (err) {
      if (err) {
        console.warn('OS Cookie Consent: could not load API', err);
        return;
      }

      var api = window.Shopify.customerPrivacy;
      if (!api) return;

      attachListeners();

      if (!api.shouldShowBanner || !api.shouldShowBanner()) return;
      if (api.currentVisitorConsent && hasConsentChoice(api.currentVisitorConsent())) return;

      showBanner();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
